    <!--<div[innerHTML]="question?.text">
 <p class="question-text">{{question?.text}}</p> 
</div>-->
<!-- <div  class="text-flex2" [ngClass]="question?.flex=='c'?'center':question?.flex=='e'?'end':'start'" 
[innerHTML]="sanitizedHtml"></div>

{{sanitizedHtml}} -->

<div class="text">

    <div class="warp-rich-text">
        <!-- placeholder="{{'questionBoard.edit.placeholder' | translate}}" -->
        <!-- (click)="$event.stopPropagation()" -->
        <que-rich-text [isText]="true" [isDisplay]="true" [isExpand]="false"
            [formControl]="valueControl"></que-rich-text>
    </div>
    <!-- [height]="isExpand?'70vh':''" [width]="isExpand?'60vw':''" -->

</div>